/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

import { BaseFiltro, Pagination } from '@data/models';

@Component({
  selector: 'app-pagination-footer',
  standalone: true,
  imports: [NgbPaginationModule],
  templateUrl: './pagination-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationFooterComponent {
  readonly data = input.required<unknown[]>();
  readonly pagination = input.required<Pagination>();
  readonly filtros = input.required<BaseFiltro>();
  readonly disabled = input.required<boolean>();
  readonly verDatos = input(true);

  readonly pageChange = output<any>();


  pageOnChange(page: number) {
    console.log('paginador', page)
    this.pageChange.emit({
      ...this.filtros(),
      start:page,
    });
  }


  getRangeStart(): number {
  const total = this.pagination().elements;
  const page = this.pagination().currentPage;
  const limit = this.filtros().limit;

  if (total === 0) return 0;

  return (page - 1) * limit + 1;
}

  getRangeEnd(): number {
const total = this.pagination().elements;

  if (total === 0) return 0;

  const start = this.getRangeStart();
  const limit = this.filtros().limit;

  return Math.min(start + limit - 1, total);
      /* const offset = this.pagination().offset;
  const limit = this.filtros().limit;
  const total = this.pagination().elements;

  return Math.min(offset + limit -1, total); */
}
}


